/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Ticket } from '@touchplan/common';
import { Side, TicketType } from '@touchplan/common';
import { Swimlane } from '../app-data/models/Swimlane';
import { TicketLayout } from '@appPlanApplication/tickets/TicketContainer';

export const setTicketWidthHelper = (data: Ticket, layout: TicketLayout, width: number) => {
	const ticketWidth =
		data.view.side === Side.PULL && (!data.view.type || data.view.type === TicketType.Task) && width
			? width
			: layout.width;
	return ticketWidth;
};

/**
 * Retrieves the swimlane to which a ticket belongs based on its position.
 * @param ticket - The ticket object.
 * @param swimlanesList - The map of swimlanes.
 * @returns The the swimlane to which the ticket belongs, or undefined if no swimlane is found.
 */
export function getSwimlaneBelonging(ticketYTop: number, swimlanesList: Map<string, Swimlane>): Swimlane {
	for (const [_, swimlane] of swimlanesList) {
		const swimlaneYTop = swimlane.view.top;
		const swimlaneYBottom = swimlane.view.bottom;
		if (ticketYTop >= swimlaneYTop && ticketYTop < swimlaneYBottom) {
			return swimlane;
		}
	}
	return undefined;
}
